module.exports = __webpack_public_path__ + "static/media/bus.82c1c1ec.svg";